<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Изменить данные заказчика
        </div>
        <DataEntryForCustomers :buttonName="'Применить'" :dataCustomer="dataCustomer" @apply="apply"/>
    </div>
</template>

<script>

import SVGModalClose from "../../../SVG/SVGModalClose";
import DataEntryForCustomers from "./DataEntryForCustomers";

export default {
    name: "ChangeCustomer",
    components: {
        SVGModalClose,
        DataEntryForCustomers
    },
    props:{
        dataCustomer:{
            type: Object
        }
    },
    methods: {
        async apply(newDataCustomer) {
            newDataCustomer.uuid = this.dataCustomer.uuid;
            await this.$store.dispatch('adminPanel/customers/SAVE_CUSTOMER', newDataCustomer);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>
